// import { useRouter } from 'next/router'
import { BrowserRouter as Router, Link, NavLink } from "react-router-dom";
// import { NavHashLink } from 'react-router-hash-link';
import { DisplayRoute } from "../routes";
// import Image from 'next/image'
import { atom, useAtom } from 'jotai'
import _ from "lodash"
import { useState, useEffect, useRef, forwardRef } from 'react'
import ReactAudioPlayer from 'react-audio-player';

// import { isSmallAtom } from "../atoms";
import {isSmallAtom, slideIndexAtom, audioPlayingAtom, audioFileAtom, videoPlayingAtom, isOptionsOpenAtom, isContrastAtom, isAnimationsPausedAtom} from '../atoms/atom.config.js'

import useDeviceSize from '../components/useDeviceSize';
import { mobileWidth } from '../constants';
import {OutlineButtonTextIcon, ButtonTextIcon, ButtonIcon, ButtonIconDisabled, ButtonStatesTextIcon, ButtonStatesFullWidthTextIcon, ButtonTextIconWhiteHover} from '../components/Button'

// assets
import logoImage from '../assets/images/default_thumb.jpg' //button_mobile_menu.svg
// import logoImage2 from './default_thumb.jpg'
import scrollDownIconBlk from '../assets/icons/icon_scrolldown_blk.svg'
import scrollDownIcon from '../assets/icons/icon_scrolldown.svg'
import scrollUpIconBlk from '../assets/icons/icon_scrollup_blk.svg'
import scrollUpIcon from '../assets/icons/icon_scrollup.svg'
import soundOnIcon from '../assets/icons/icon_sound_on.svg'
import soundOffIcon from '../assets/icons/icon_sound_off.svg'
import lineIconMobile from "../assets/icons/mobile_menu_line.svg"

// import closeWhiteIcon from '../assets/icons/icon_close_wht.svg'
import closeIcon from '../assets/icons/icon_close.svg'
import optionsIcon from '../assets/icons/icon_options.svg'
import optionsIconHover from'../assets/icons/icon_options_h.svg'
import closeOptionsIcon from '../assets/icons/icon_close_wht.svg'
import closeOptionsIconHover from '../assets/icons/icon_close_wht_h.svg'
import pauseIcon from '../assets/icons/icon_pause.svg'
import pauseIconOff from '../assets/icons/icon_pause_off.svg'
import pauseIconHover from'../assets/icons/icon_pause_h.svg'
import pauseIconHoverAlt from'../assets/icons/icon_pause_off_h.svg'
import contrastIcon from '../assets/icons/icon_contrast.svg'
import contrastIconOff from '../assets/icons/icon_contrast_off.svg'
import contrastIconHover from '../assets/icons/icon_contrast_h.svg'
import contrastIconHoverAlt from '../assets/icons/icon_contrast_alt_h.svg'
import soundIcon from '../assets/icons/icon_sound.svg'
import soundIconOff from '../assets/icons/icon_sound_off.svg'
import soundIconHover from '../assets/icons/icon_sound_h.svg'
import soundIconHoverAlt from '../assets/icons/icon_sound_off_alt_h.svg'

// import creditsIcon from '../assets/icons/icon_credits.svg'

// assets
// import menuImage from '../assets/icons/button_mobile_menu.svg'
// <Image src={menuImage} alt="Menu" width={16} height={16} /> 
// <MobileMenu stroke='black' fill='red' strokeWidth={1.5} width='38px' height='38px'/>

// import React from "react";
// // import { ReactComponent as MobileMenu } from "../assets/icons/button_mobile_menu.svg";

// import dynamic from 'next/dynamic'
// const MobileMenu = dynamic(() => import('../assets/icons/button_mobile_menu.svg'), {
//   ssr: false,
// })

// svgr: https://react-svgr.com/docs/next/
// import MobileMenu from '../assets/icons/button_mobile_menu.svg'
// import MobileMenu from '../assets/icons/icon_object.svg'
import menuIcon from '../assets/icons/icon_menu.svg'
import logoIcon from '../assets/icons/logo_RBA3.svg'
// import logoIcon from '../assets/icons/icon_security_large.svg' //logo_RBA.svg'
//import audioFile from '../assets/sounds/RBA 220816.mp3'


export default function Footer(props) {
  //console.log(props);
  // const router = useRouter()
  const names = ['Ada Lovelace', 'Grace Hopper', 'Margaret Hamilton'];

  const [isSmall, setIsSmall] = useAtom(isSmallAtom);
  const [savedSlideIndex, setSavedSlideIndex] = useAtom(slideIndexAtom);
  //const [showMenu, setShowMenu] = useState(true);
  //const [showMenu, setShowShareModal] = useAtom(showShareModalAtom);
  const [isAudio, setIsAudio] = useAtom(audioPlayingAtom); 
  const [isOptionsOpen, setIsOptionsOpen] = useAtom(isOptionsOpenAtom);
  const [isContrast, setIsContrast] = useAtom(isContrastAtom);
  const [isAnimationPaused, setAnimationPaused] = useAtom(isAnimationsPausedAtom);
  const [audioFile, setAudioFile] = useAtom(audioFileAtom); // "blah.mp3"
  const [audioPlayer, setAudioPlayer] = useState(null); // <audio>
  const [isVideoPlaying, setIsVideoPlaying] = useAtom(videoPlayingAtom);
  const player = useRef();

  const [isCredits, setIsCredits] = useState(true);

  const [width, height] = useDeviceSize();

  // hack for safari desktop not getting focus on parent div element
  const optionsMenuDesktopRef = useRef(null); 

  const onBlurAudio = () => {
    //console.log("onBlurAudio", document.activeElement);
    //toggleOptions()

    // very custom specific action required here - we need to see if we tabbed to the main navigation menu, if so then close the options    
    setTimeout(() => {
      //console.log("onBlurAudio timeout", document.activeElement, document.activeElement.id);
      if(document.activeElement) {
        if(document.activeElement.id === "introlink") {
          //console.log("ok")
          //isOptionsOpen = false;
          if(isOptionsOpen) {
            setIsOptionsOpen(false);
          }
        }
      }
    }, 250);
  }

  // hack for safari desktop only: https://stackoverflow.com/questions/61245883/why-blur-and-focus-doesnt-work-on-safari
  const onForceFocusButton = (e) => {
    console.log("onForceFocusButton", e.target, optionsMenuDesktopRef.current);
    if(optionsMenuDesktopRef.current) {
      console.log("ok focus the menu...")
      optionsMenuDesktopRef.current.focus();
    }
    //e.target.focus();// Add me
  };
  const onFocusOptions = (e) => {
    console.log("onFocusOptions", e.target);
  };

  const onBlurOptions = () => {
    console.log("onBlurOptions", document.activeElement, document.activeElement.id)
    setTimeout(() => {
      //console.log("onBlurOptions", document.activeElement, document.activeElement.id)
      // this needs to stay open if we are just tabbing to each individual options item
      if(document.activeElement.id === "options_id" || document.activeElement.id === "animations_id" || document.activeElement.id === "contrast_id" || document.activeElement.id === "sound_id") {
        console.log("ignore options close", document.activeElement.id)
      } else {
        console.log("ok close options", isOptionsOpen, document.activeElement.id)
        if(isOptionsOpen) {
          setIsOptionsOpen(false);
        }
      }
    }, 250);
  }

  const onBlurOptionsMobile = () => {
    onBlurOptions();
    // setTimeout(() => {
    //   console.log("onBlurOptionsMobile", document.activeElement, document.activeElement.id)
    //   // this needs to stay open if we are just tabbing to each individual options item
    //   if(document.activeElement.id === "options_id" || document.activeElement.id === "animations_id" || document.activeElement.id === "contrast_id" || document.activeElement.id === "sound_id") {
    //     console.log("ignore options close", document.activeElement.id)
    //   } else {
    //     console.log("ok close options", isOptionsOpen, document.activeElement.id)
    //     if(isOptionsOpen) {
    //       //setIsOptionsOpen(false);
    //     }
    //   }
    // }, 250);
  }
  
  
  const toggleAudio = () => {
    let v = !isAudio
    // console.log("audio", v, audioFile, audioPlayer)
    // // FIXME: play audio
    // if(audioPlayer) {
    //   if(v) {
    //     audioPlayer.play()
    //   } else {
    //     audioPlayer.pause()
    //   }
    // }
    console.log("player", player, v)
    if(player) {
      if(player.current.audioEl) {
        player.current.audioEl.current.muted = false;
        if(v) {
          player.current.audioEl.current.play()
          player.current.audioEl.current.currentTime = 0;
        } else {
          player.current.audioEl.current.pause()
          player.current.audioEl.current.currentTime = 0;
        }
      }      
    }

    setIsAudio(v)
  };

  const toggleOptions = () => {
    let v = !isOptionsOpen
    console.log("toggleOptions", v)
    setIsOptionsOpen(v)
  };

  const toggleAnimationPaused = () => {
    let v = !isAnimationPaused
    console.log("toggleAnimationPaused", v)
    setAnimationPaused(v)
  };

  const toggleContrast = () => {
    let v = !isContrast
    console.log("toggleContrast", v)
    setIsContrast(v)
  };

  // useEffect(() => {
  //   //console.log("w/h changed:", width,height)
  //   //setIsSmall( width < mobileWidth )
  //   let song = new Audio(audioFile);
  //   //song.muted = true;
  //   song.loop = true;
  //   // song.addEventListener('ended', function() {
  //   //     this.currentTime = 0;
  //   //     this.play();
  //   // }, false);
  //   song.pause();
  //   setAudioPlayer(song);
  //   console.log("loaded sound", audioFile)

  // }, [isSmall,audioFile]);

  useEffect(() => {
    console.log("loaded sound", audioFile, isAudio)
    console.log("footer video playing changed", isVideoPlaying)
    
    // when the audio preloads + autoplays, we need to toggle OFF the muted property if isAudio state
    if(player && audioFile) {
      if(player.current.audioEl) {
        if(isAudio && !isVideoPlaying) {
          //player.current.audioEl.current.play()
          console.log("unmute audio please", player.current.audioEl.current.muted, player.current.audioEl.current.currentTime)
          
          player.current.audioEl.current.muted = false;
          player.current.audioEl.current.play()
          player.current.audioEl.current.currentTime = 0;
        } else {
          //player.current.audioEl.current.pause()
          console.log("mute audio please", player.current.audioEl.current.muted, player.current.audioEl.current.currentTime)
          player.current.audioEl.current.muted = true;
          player.current.audioEl.current.pause()
          player.current.audioEl.current.currentTime = 0;
        }
      }
    }

  }, [isSmall,audioFile,isVideoPlaying]);

  useEffect(() => {
    console.log("savedSlideIndex changed:", savedSlideIndex)
  }, [savedSlideIndex]);


  const highlighted = `underline decoration-2 underline-offset-8`;
  const isLastSlide = (savedSlideIndex == props.slideCount-1) || (savedSlideIndex == 1 && props.slideCount == -1)
  const isFirstSlide = (savedSlideIndex == 0) || (savedSlideIndex == 0 && props.slideCount == -1)
  const slideIndexValid = (props.slideCount > 0) && !isLastSlide
  // const bottomOffset = (isSmall) ? "absolute right-0 w-full h-full bg-black/60 flex flex-row bottom-0" : "absolute right-0 w-full h-full bg-black/60 flex flex-row bottom-[25px]"
  //const footerMobileBar = (isOptionsOpen) ? 'absolute bottom-0 right-0 w-full h-full bg-rba-gray-options text-white flex flex-row' : 'absolute bottom-0 right-0 w-full h-full bg-white text-black flex flex-row';
  const footerMobileBar = 'absolute bottom-0 right-0 w-full h-full bg-white text-black flex flex-row';
  const footerMobileBarDark = (isOptionsOpen) ? 'absolute bottom-0 left-0 w-1/2 sm:w-[166px] h-full bg-rba-gray-options text-white flex flex-row' : '';

  return (
    <div className="block fixed w-full bottom-0 h-footerbarHt z-30" id="footer">
      {
        <div className='flex '>
          <div className="flex justify-start grow items-center">
            {/* <div className="mx-8 w-[80px]"> */}
            {/* <NavLink to="/intro">
             <img src={logoIcon} className="" alt="RBA Logo"  />
             </NavLink>
            */}
            {/* <ButtonTextIcon text="Scroll down" icon={scrollDownIcon} iconSize="18" onClick={() => console.log("click")}/> */}
            {/* </div>  */}
          </div>
          {/* {!isSmall && savedSlideIndex != props.slideCount-1 ? */}
          {/* { (savedSlideIndex != props.slideCount-1) ? */}
          <div className="flex w-full font-bold ">
            {/* {savedSlideIndex}/{props.slideCount} bg-red-500 */}
            {isSmall ?
              <div className={footerMobileBar} onBlur={onBlurOptionsMobile}>
                <div className={footerMobileBarDark}></div>
                <div className="w-[15px]"></div>
                <div className="z-10"><ButtonTextIcon text="Options" id="options_id" textClr={ (isOptionsOpen) ? 'text-white' : 'text-black'} icon={(isOptionsOpen) ? closeOptionsIconHover : optionsIcon} iconSize="32" onClick={toggleOptions} tabIndex="2"/></div>
                <div className="grow sm:grow-0 items-center text-center flex flex-row pr-[50px] sm:pl-[20px]">
                  {/* flex-1 flex-col justify-end justify-items-end items-end place-content-end */}
                  {/* <div className="grow"></div> */}
                  {!isOptionsOpen && <img className="h-[36px] mt-[6px] m-auto " src={lineIconMobile} alt="line" height="36px"  /> }
                </div>
                {/* empty div to grow the space when above is false */}
                <div className="grow-0 sm:grow"></div>

                { isOptionsOpen && 
                  <div className="absolute bottom-[48px] left-0 flex flex-col space-y-0 w-full animate-fadein" >
                    <ButtonStatesFullWidthTextIcon id="animations_id" text="Pause animations" textAlt="Play animations" icon={pauseIconHover} iconAlt={pauseIconHoverAlt} iconSize="27" iconSizeAlt="27" initState={isAnimationPaused} onClick={toggleAnimationPaused} tabIndex="2" />
                    <ButtonStatesFullWidthTextIcon id="contrast_id" text="High contrast on" textAlt="High contrast off" icon={contrastIconHover} iconAlt={contrastIconHoverAlt} iconSize="27" iconSizeAlt="27" initState={isContrast} onClick={toggleContrast} tabIndex="2" />
                    <ButtonStatesFullWidthTextIcon id="sound_id" text="Turn sound on" textAlt="Turn sound off" icon={soundIconHover} iconAlt={soundIconHoverAlt} iconSize="27" iconSizeAlt="27" initState={isAudio} onClick={toggleAudio} tabIndex="2" />
                  </div>
                }
                {/* <ButtonStatesTextIcon text="Options" textAlt="Options" initState={isOptionsOpen} icon={optionsIcon} iconAlt={closeBlkIcon} iconSize="32" iconSizeAlt="16" onClick={toggleOptions} tabIndex="2" /> */}
                {/* {isAudio ? 
                  <ButtonTextIcon text="Sound on" icon={soundOnIcon} iconSize="20" onClick={toggleAudio} tabIndex="2"/>
                  : <ButtonTextIcon text="Sound off" icon={soundOffIcon} iconSize="20" onClick={toggleAudio} tabIndex="2" /> } */}
                {/* <ButtonTextIcon text={audio ? "Sound on" : "Sound off"} icon={soundOnIcon} iconSize="18" onClick={toggleAudio}/> */}
                {/* <div className="grow">
                </div> */}
                {/* { (isCredits && isLastSlide && false) &&
                  <ButtonTextIcon text="Background credits" icon={creditsIcon} iconSize="24" onClick={props.onCreditsClick}/>
                } */}
                {/* { !isOptionsOpen ? <> */}
                { (props.slideCount >= -1 && !isFirstSlide) ?
                  <ButtonIcon icon={ (isOptionsOpen) ? scrollUpIconBlk : scrollUpIconBlk} iconSize="24" onClick={props.onScrollUpClick } tabIndex="13" iconAlt="scroll up"/> 
                  : <ButtonIconDisabled icon={(isOptionsOpen) ? scrollUpIconBlk : scrollUpIconBlk} iconSize="24" tabIndex="13" iconAlt="scroll up"/> 
                }
                { (props.slideCount >= -1 && !isLastSlide) ?
                  <ButtonIcon icon={(isOptionsOpen) ? scrollDownIconBlk : scrollDownIconBlk} iconSize="24" onClick={props.onScrollDownClick} tabIndex="12" iconAlt="scroll down"/> 
                  : <ButtonIconDisabled icon={(isOptionsOpen) ? scrollDownIconBlk : scrollDownIconBlk} iconSize="24" tabIndex="12" iconAlt="scroll down"/> 
                  }
                {/* </> : */}
                {/* <ButtonIcon icon={closeIcon} iconAlt="options" iconSize="18" onClick={toggleOptions} tabIndex="12"/>  */}
                {/* } */}
                  <div className="w-[15px]"></div>
                
              </div>
               
              :
              <div className="flex flex-row justify-start grow w-full mt-[-20px]" onBlur={onBlurOptions}>
                {/* FIXED: leave the onBlur as is - just needded to add the fopcus() call within the button itself */}
                {/* for safari only auto closes if we give it a tabindex, but we need those for the internal buttons??? */}
                {/*  onBlur={onBlurOptions} onFocus={onFocusOptions} onClick={onForceFocusButton} */}
                {/* onClick={onForceFocusButton} ref={optionsMenuDesktopRef}  */}
                  <div className="w-[20px]">
                  {/* <audio autoplay>
                      <source src={audioFile} type="audio/mpeg"></source>
                      Your browser does not support the audio element.
                  </audio> */}
                  </div>
                  {/* 15/2 fix: when clicking away from the options menu, the icon doesnt change back to close icon so we are swapping out the WHOLE ButtonStatesTextIcon element here and just setting the correct icons */}
                  {/* <ButtonStatesTextIcon id="options_id" text="Options" textAlt="Options" initState={isOptionsOpen} icon={optionsIcon} iconAlt={closeOptionsIcon} iconHover={optionsIconHover} iconHoverAlt={closeOptionsIconHover} iconAltText="toggle options" iconSize="32" iconSizeAlt="32" onClick={toggleOptions} tabIndex="2" /> */}
                  {(isOptionsOpen) ? <ButtonStatesTextIcon id="options_id" text="Options" textAlt="Options" initState={isOptionsOpen} icon={closeOptionsIcon} iconAlt={closeOptionsIcon} iconHover={closeOptionsIconHover} iconHoverAlt={closeOptionsIconHover} iconAltText="toggle options" iconSize="32" iconSizeAlt="32" onClick={toggleOptions} tabIndex="2" /> : <ButtonStatesTextIcon id="options_id" text="Options" textAlt="Options" initState={isOptionsOpen} icon={optionsIcon} iconAlt={optionsIcon} iconHover={optionsIconHover} iconHoverAlt={optionsIconHover} iconAltText="toggle options" iconSize="32" iconSizeAlt="32" onClick={toggleOptions} tabIndex="2" />}
                  { isOptionsOpen && 
                  <div className="absolute bottom-[72px] left-[20px] flex flex-col space-y-1 w-[227px] animate-fadein" aria-expanded="true" role="toolbar" aria-label="Options menu">
                    <ButtonStatesTextIcon id="animations_id" text="Pause animations" textAlt="Play animations" icon={pauseIcon} iconAlt={pauseIconOff} iconHover={pauseIconHover} iconHoverAlt={pauseIconHoverAlt} iconAltText="toggle animations" iconSize="27" iconSizeAlt="27" initState={isAnimationPaused} onClick={toggleAnimationPaused} tabIndex="2" />
                    <ButtonStatesTextIcon id="contrast_id" text="High contrast on" textAlt="High contrast off" icon={contrastIcon} iconAlt={contrastIconOff} iconHover={contrastIconHover} iconHoverAlt={contrastIconHoverAlt} iconAltText="toggle contrast" iconSize="27" iconSizeAlt="27" initState={isContrast} onClick={toggleContrast} tabIndex="2" />
                    <ButtonStatesTextIcon id="sound_id" text="Turn sound on" textAlt="Turn sound off" icon={soundIcon} iconAlt={soundIconOff} iconHover={soundIconHover} iconHoverAlt={soundIconHoverAlt} iconAltText="toggle sound" iconSize="27" iconSizeAlt="27" initState={isAudio} onClick={toggleAudio} tabIndex="2" blurEvent={onBlurAudio} />
                  </div>
                  }
                {/* {isAudio ? 
                  <ButtonTextIcon text="Sound on" icon={soundOnIcon} iconSize="20" onClick={toggleAudio} tabIndex="2"/>
                  : <ButtonTextIcon text="Sound off" icon={soundOffIcon} iconSize="20" onClick={toggleAudio} tabIndex="2"/> } */}
                <div className="grow"></div>
                {/* { (isCredits && isLastSlide && false) &&
                  <ButtonTextIcon text="Background credits" icon={creditsIcon} iconSize="24" onClick={props.onCreditsClick}/>
                } */}
                {/* {savedSlideIndex}/{props.slideCount-1} */}
                { (slideIndexValid) &&
                  <ButtonTextIconWhiteHover text="Scroll down" icon={scrollDownIcon} iconSize="20" onClick={props.onScrollDownClick} tabIndex="10" iconAlt="scroll down"/> }
                
                <div className="w-[20px]"></div>
              </div>
            }          
            {/* </div> */}
            {/* : <div className="flex flex-none justify-end mx-5 w-[80px]"> */}
          </div> 
          
          
          
        </div >
       
      }
     
     {
      <ReactAudioPlayer
        // ref={(element) => { this.player = element; }}
        ref={player}
        src={audioFile}
        autoPlay
        loop
        //{(isAudio) ? autoPlay : ''}
        //{(isAudio) && muted}
        muted
      />
     }
    </div>
  )
}
